import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Preline creates its collection in autoInit; the observer can fire first.
        if (entry.isIntersecting && window.$hsTextareaAutoHeightCollection) {
          const instance = window.HSTextareaAutoHeight?.getInstance(this.element, true)
          instance?.element?.textareaSetHeight(3)
        }
      })
    }, { threshold: 0 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
